import { Component, Injector, Optional } from '@angular/core';
import { ClienteUnicoAppDto, ClienteUnicoServiceProxy, OrderDto, OrdersServiceProxy } from '../services/service-proxy/service-proxies';
import { Observable, finalize, switchMap, tap } from 'rxjs';
import { UiService } from '../services/ui.service';
import { Router } from '@angular/router';
import { AppService } from '../services/app.service';
import { AuthenticatedResult, OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {

  title = 'Mi Cuenta - Puppis';
  isLoading = false;

  model? : ClienteUnicoAppDto | null;

  /** Ultimas compras del resumen. Se cargan aparte de model. */
  ultimasCompras? : OrderDto[] | null;
  isAuthenticated$: Observable<AuthenticatedResult>;

  showClustersInfo : boolean ;
  showBenfitsDetail : boolean ;
  promoClusterNameToShow? : string; 


  linkFB = '';
  linkIG = '';
  linkYT = '';

  sub1_AR = 'Revisá el estado de envío de tus órdenes y pedidos de compra.';
  sub2_AR = 'Editá tus direcciones de entrega.';

  sub1_CO = 'Revisa el estado de envío de tus órdenes y pedidos de compra.';
  sub2_CO = 'Edita tus direcciones de entrega.';

  
  constructor(public clienteUnicoService: ClienteUnicoServiceProxy,
              private ordersService: OrdersServiceProxy, 
              public appService : AppService,
              public oidcSecurityService: OidcSecurityService ) {

                this.isAuthenticated$ = this.oidcSecurityService.isAuthenticated$;

                this.showClustersInfo  = appService.countryCode == 'AR';
                this.showBenfitsDetail = appService.countryCode == 'CO';

                if(appService.countryCode == 'AR'){
                  this.linkFB = "https://www.facebook.com/PuppisArgentina";
                  this.linkIG = "https://www.instagram.com/puppisarg" ;
                  this.linkYT = "https://www.youtube.com/@puppisarg" ;
                }
                else
                {
                  this.linkFB = "https://www.facebook.com/PuppisColombia";
                  this.linkIG = "https://www.instagram.com/puppiscol" ;
                  this.linkYT = "https://www.youtube.com/@puppiscol" ;
                }

    // https://www.pluralsight.com/guides/how-to-use-the-@injectable-decorator
    // --public-host localhost:4200

  }

  ngOnInit(){


   /* this.isAuthenticated$.pipe(switchMap(({ isAuthenticated }) => this.loadData()))
                         .subscribe(
                            data => this.DataEventRecords = data,
                            () => console.log('getData Get all completed')
      );

      this.oidcSecurityService.userData$.subscribe(({userData}) => {
          console.log('Get userData: ', userData);

          if (userData) {
              console.log('userData: ', userData);

              if (userData !== '' && userData.role) {
                  for (let i = 0; i < userData.role.length; i++) {
                      if (userData.role[i] === 'dataEventRecords.admin') {
                          this.hasAdminRole = true;
                      }
                      if (userData.role[i] === 'admin') {
                      }
                  }
              }
          }
      });*/

    this.loadData();
    this.cargarUltimasCompras();
  }

  /**
   * Las ultimas compras se piden aparte y sin bloquear la home: la seccion
   * aparece cuando llega la respuesta. GetOrders tarda unos 5s incluso tibio,
   * asi que esperarlo antes de pintar la pantalla haria que la home se sienta
   * lenta por una seccion que esta al final.
   */
  cargarUltimasCompras() {

    const cacheadas = this.appService.getOrdersData(0);

    if(cacheadas){
      this.ultimasCompras = cacheadas;
      return;
    }

    this.ordersService
        .getOrders(this.appService.idUnico, null, this.appService.countryCode, null, null, 0, null)
        .subscribe({
          next: (response) => {
            this.ultimasCompras = response.items ?? [];
            this.appService.saveOrdersData(this.ultimasCompras, 0);
          },
          // Un fallo acá no debe romper la home: la seccion simplemente no aparece.
          error: (e) => console.warn('No se pudieron cargar las ultimas compras', e)
        });
  }

  loadData() {

    let idUnico = this.appService.idUnico!;

    this.model = this.appService.getClienteAppData(idUnico);
    this.defineClusterToshow();

    if(!this.model) {

      this.isLoading = true;
      this.clienteUnicoService
          .getForApp(idUnico, null)
          .pipe(finalize( () => this.isLoading = false)) 
          .subscribe( (response) => {

            this.model = response;
            this.appService.saveClienteAppData(this.model);
            this.defineClusterToshow();
            console.log('guardado data cliente HOME', response);
        });

    }
    else 
      console.log('restaurado data cliente HOME', this.model);
  }

  defineClusterToshow(){

    if(this.model?.clienteClusters) {
         
      //  definir el cluster segun la prioridad
      if(this.model.clienteClusters.some(c=> c.name == 'Black') )
        this.promoClusterNameToShow = 'Black';
      else if(this.model.clienteClusters.some(c=> c.name == 'Gold') )
        this.promoClusterNameToShow = 'Gold';
      else if(this.model.clienteClusters.some(c=> c.name == 'Silver') )
        this.promoClusterNameToShow = 'Silver';
      
      //this.promoClusterNameToShow = 'Gold';
      console.log('defineClusterToshow', this.model.clienteClusters)
    }
  }

  getName() {

    if(this.model?.nombreCompletoPrincipal)
      return this.model.nombreCompletoPrincipal;

    if(this.model?.nombrePrincipal && this.model?.apellidoPrincipal)
      return this.model?.nombrePrincipal + ' ' + this.model?.apellidoPrincipal;

    return null;
  }

  /**
   * El saludo usa solo el nombre de pila. Se prefiere nombrePrincipal, que es el
   * campo dedicado, antes que partir nombreCompletoPrincipal: hay registros donde
   * el completo viene como "Apellido Nombre" y quedaria el apellido.
   */
  getPrimerNombre() {

    if(this.model?.nombrePrincipal)
      return this.model.nombrePrincipal.trim().split(/\s+/)[0];

    const completo = this.getName();

    return completo ? completo.trim().split(/\s+/)[0] : null;
  }

  // puntosNextTier en 0 significa que no hay nivel siguiente: el cliente ya esta
  // en el mas alto. Llega como string y con separador de miles ("2,600"), asi que
  // se limpia antes de comparar. Si viene vacio o nulo se devuelve false a
  // proposito: es un dato desconocido, no una confirmacion de nivel maximo.
  estaEnNivelMasAlto() : boolean {

    const valor = this.model?.fidelidadPointsTotal?.puntosNextTier;

    if(valor === null || valor === undefined || String(valor).trim() === '')
      return false;

    const puntos = Number(String(valor).replace(/[^\d]/g, ''));

    return !isNaN(puntos) && puntos === 0;
  }

  changeUser(valor : string){
    this.appService.deleteClienteAppData();
    this.appService.deleteClienteUnicoData();
    this.appService.idUnico = valor;
    this.loadData();
  }

}
